// What fills the content area while something is on its way.
//
// Deliberately quiet: no spinner that starts instantly, because a fast response
// then shows a flash of spinner and reads as slower than doing nothing. The
// delay is CSS-only so it costs no state and no timer.
import './pageLoading.css';

export function PageLoading({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="page-loading flex min-h-[40vh] items-center justify-center" role="status">
      <span className="text-sm text-gray-500">{label}…</span>
    </div>
  );
}
